namespace TabAurous.OMS {
    export interface ExchangeRateRow {
        ExchangeRateId?: number;
        ExchTypeId?: number;
        FixedName?: string;
        CurrencyId?: number;
        FromDate?: string;
        ToDate?: string;
        ExchRate?: number;
        Narration?: string;
        Extra1?: string;
        Extra2?: string;
        CurrencyName?: string;
    }

    export namespace ExchangeRateRow {
        export const idProperty = 'ExchangeRateId';
        export const nameProperty = 'Narration';
        export const localTextPrefix = 'OMS.ExchangeRate';
        export const lookupKey = 'ExchangeRate';

        export function getLookup(): Q.Lookup<ExchangeRateRow> {
            return Q.getLookup<ExchangeRateRow>('ExchangeRate');
        }
        export const deletePermission = 'Masters:ExchangeRate:Delete';
        export const insertPermission = 'Masters:ExchangeRate:Add';
        export const readPermission = '*';
        export const updatePermission = 'Masters:ExchangeRate:Edit';

        export declare const enum Fields {
            ExchangeRateId = "ExchangeRateId",
            ExchTypeId = "ExchTypeId",
            FixedName = "FixedName",
            CurrencyId = "CurrencyId",
            FromDate = "FromDate",
            ToDate = "ToDate",
            ExchRate = "ExchRate",
            Narration = "Narration",
            Extra1 = "Extra1",
            Extra2 = "Extra2",
            CurrencyName = "CurrencyName"
        }
    }
}
